/* eslint-disable import/no-unresolved */
/* eslint-disable import/extensions */
import { createContext } from "react";
import { WindowMeasure } from "~/hooks/useWindowMeasure";

const WindowMeasureContext = createContext<WindowMeasure>({
  width: 0,
  height: 0,
  isResizing: true,
});

export default WindowMeasureContext;
